import { createFileRoute } from "@tanstack/react-router";

// Keep the route mounted so the project workspace can render the project root view
// when the current project path is "/".
function ProjectIndex() {
  return null;
}

export const Route = createFileRoute("/project/$projectId/")({
  component: ProjectIndex,
});
